import Process from './Process'

export default Process
